"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _loop = function(i) {
    var cell = document.createElement("div");
    var value = numbers[i - 1] + 1;
    cell.className = "cell";
    cell.innerHTML = value;
    var left = i % 4;
    var top = (i - left) / 4;
    cells.push({
        value: value,
        left: left,
        top: top,
        element: cell
    });
    cell.style.left = "".concat(left * cellSize, "px");
    cell.style.top = "".concat(top * cellSize, "px");
    field.append(cell);
    cell.addEventListener("click", function() {
        move(i);
    });
};
var field = document.querySelector(".field");
var cellSize = 100;
var empty = {
    top: 0,
    left: 0,
    value: 0
};
var cells = [];
cells.push(empty);
function move(index) {
    var cell = cells[index];
    var leftDiff = Math.abs(empty.left - cell.left);
    var topDiff = Math.abs(empty.top - cell.top);
    if (leftDiff + topDiff > 1) return;
    cell.element.style.left = "".concat(empty.left * cellSize, "px");
    cell.element.style.top = "".concat(empty.top * cellSize, "px");
    var emptyLeft = empty.left;
    var emptyTop = empty.top;
    empty.left = cell.left;
    empty.top = cell.top;
    cell.left = emptyLeft;
    cell.top = emptyTop;
    var isFinished = cells.every(function(cell) {
        return cell.value === cell.top * 4 + cell.left;
    });
    if (isFinished) {
        var winMessage = document.querySelector(".message.message-win");
        var restartMessage = document.querySelector(".restart");
        winMessage.classList.remove("hidden");
        restartMessage.classList.remove("hidden");
    }
}
var numbers = _to_consumable_array(Array(15).keys()).sort(function() {
    return Math.random() - 0.5;
});
for(var i = 1; i <= 15; i++)_loop(i);
function restart() {
    cells.forEach(function(cell, index) {
        var left = index % 4;
        var top = (index - left) / 4;
        cell.left = left;
        cell.top = top;
        if (cell.element) {
            cell.element.style.left = "".concat(left * cellSize, "px");
            cell.element.style.top = "".concat(top * cellSize, "px");
        }
    });
    document.querySelector(".message.message-win").classList.add("hidden");
    document.querySelector(".restart").classList.add("hidden");
}
var restartButton = document.querySelector(".restart");
if (restartButton) restartButton.addEventListener("click", restart);

//# sourceMappingURL=index.33955e12.js.map
